import React, { FC } from "react";
import type { AutomationHeroProps } from "@/types";
import { Cta } from "../cta";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const AutomationHero: FC<AutomationHeroProps> = ({
  label,
  title,
  description,
  cover,
  cta,
}) => {
  return (
    <section className="automationHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description?.textCol1,
            textCol2: description?.textCol2,
          }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover?.file?.url && (
          <Image
            className="automationHero--cover"
            src={cover as any}
            alt={cover.title}
          />
        )}
        {/* TODO: Temporary hidden */}
        <Cta cta={cta} className="automationHero--cta" />
      </div>
    </section>
  );
};
